"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactTabs = require("react-tabs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\n\t&.react-tabs__tab-panel--selected {\n\t\tdisplay: block;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledTabPanel = (0, _styledComponents.default)(_reactTabs.TabPanel)(_templateObject());
StyledTabPanel.displayName = 'StyledTabPanel';
StyledTabPanel.tabsRole = 'TabPanel';
/** @component */

var _default = StyledTabPanel;
exports.default = _default;